import React from 'react';

import { Link } from 'react-router-dom';
import Text from '../../text';
import { DotSeparator } from '../../atoms/separator';
import { Color } from '../../../styles/colors';
type Props = {
  items: {
    url: string;
    text: string;
    id: string;
  }[];
  className?: string;
};

const LegalLinks = ({ items, className }: Props) => (
  <div className={`${className || ''} d-sm-flex align-items-sm-center`}>
    <div className={`d-sm-flex flex-sm-wrap align-items-sm-center`}>
      <Text el="p" type="caption1-blinkui" user1stId="footer-blink-llc">
        ©{new Date().getFullYear()} Blink Health LLC
      </Text>
      <DotSeparator margin={8} />
      {items.map((link, index) => (
        <React.Fragment key={link.text}>
          <Link id={link.id} className="d-sm-flex align-items-sm-center" key={link.url} to={link.url}>
            <Text el="span" type="caption1-blinkui" color={Color.tertiary100} user1stId={`footer-${link.id}`}>
              {link.text}
            </Text>
          </Link>
          {index < items.length - 1 && <DotSeparator margin={8} />}
        </React.Fragment>
      ))}
    </div>
  </div>
);

export default LegalLinks;
